import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import 'moment/locale/id'  // without this line it didn't work

moment.locale('id')
Vue.use(VueMoment)
Vue.prototype.moment = moment
